<template>
    <!--弹窗-->
    <el-dialog width="550px" :title="title" :visible.sync="visible" :before-close="handleClose" top="10vh">
        <el-form label-width="50px" size="mini">
            <el-form-item label="">
                <span>广告组合名称：{{objData.ad_min_name}}</span>
                <div>
                    <span>大词建议竞价：</span>
                    <el-input-number v-model="objData.suggest_bidding" style="width: 150px;margin-left:60px;" :min="0.01" label="请输入大词建议竞价"></el-input-number>
                </div>
                <div style="margin-top:12px;">
                    <span>目标acos（0.01 ~ 1）：</span>
                    <el-input-number v-model="objData.target_acos" style="width: 150px;margin-left: 8px;" :min="0.01" :max="1" label="请输入大词建议竞价"></el-input-number>
                </div>
                <el-input
                    type="textarea"
                    style="width: 420px;margin-top:12px;"
                    :rows="8"
                    placeholder="请输入词根数据，已换行区分"
                    v-model="objData.manual_root">
                </el-input>
            </el-form-item>
            <!-- <el-form-item label="" v-for="(item, i) in listData" :key="i">
                <span>广告组合名称：{{item.ad_min_name}}</span>
                <div>
                    <span>大词建议竞价：</span>
                    <el-input-number v-model="item.suggest_bidding" style="width: 150px;margin-left:60px;" :min="0.01" label="请输入大词建议竞价"></el-input-number>
                </div>
                <div style="margin-top:12px;">
                    <span>目标acos（0.01 ~ 1）：</span>
                    <el-input-number v-model="item.target_acos" style="width: 150px;margin-left: 8px;" :min="0.01" :max="1" label="请输入大词建议竞价"></el-input-number>
                </div>
                <el-input
                    type="textarea"
                    style="width: 420px;margin-top:12px;"
                    :rows="8"
                    placeholder="请输入词根数据，已换行区分"
                    v-model="item.manual_root">
                </el-input>
            </el-form-item> -->
        </el-form>
        <el-row style="margin-top:17px; ">
            <el-button
                style="float:right;margin-left:6px;"
                size="mini"
                type="danger"
                plain
                @click="handleClose(true)"
            >取 消</el-button>
            <el-button style="float:right" size="mini" type="primary" @click="submitForm('formData')" :loading="loading">确定</el-button>
        </el-row>
    </el-dialog>
</template>
<script>
import * as api from "@/api/adv/adv";
import { str_arr } from "@/utils/method";
export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ""
        },
        record_id: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            loading: false,
            objData: {},
            checked: true
        };
    },
    methods: {
        onData(obj) {
            this.objData = obj;
        },
        // 保存信息
        submitForm() {
            let obj = {
                record_id: this.record_id,
                ad_search_word_id: this.objData.ad_search_word_id,
                ad_min_name_dict: {}
            };
            let arr = [];
            if (this.objData.manual_root) {
                arr = str_arr(this.objData.manual_root);
            }
            obj.ad_min_name_dict = {
                ad_min_name: this.objData.ad_min_name,
                id: this.objData.id,
                suggest_bidding: this.objData.suggest_bidding,
                target_acos: this.objData.target_acos,
                manual_root: arr
            };
            // for (let i = 0; i < this.listData.length; i++) {
            //     let arr = [];
            //     if (this.listData[i].manual_root) {
            //         arr = str_arr(this.listData[i].manual_root);
            //     }
            //     obj.ad_min_name_list.push({
            //         ad_min_name: this.listData[i].ad_min_name,
            //         id: this.listData[i].id,
            //         suggest_bidding: this.listData[i].suggest_bidding,
            //         target_acos: this.listData[i].target_acos,
            //         manual_root: arr
            //     });
            // }
            this.loading = true;
            api.update_ad_min_name_by_dict(obj)
                .then(res => {
                    if (res.code === 0) {
                        this.$message({
                            type: "success",
                            message: "更新成功"
                        });
                        this.handleClose(false);
                        this.$emit("close-onlist", this.record_id);
                    } else {
                        this.loading = false;
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.loading = false;
                    this.$message({
                        type: "error",
                        message: "网络出现问题，请查看数据是否添加完成！"
                    });
                });
        },
        // 关闭弹窗
        handleClose(isshow) {
            this.loading = false;
            this.objData = {};
            this.$emit("close-callback", isshow);
        }
    }
};
</script>
<style type="text/scss" lang="scss" scoped>
.aa {
    height: calc(100vh - 190px);
    overflow: auto;
    border: 1px solid #ebeef5;
    /deep/ ::-webkit-scrollbar {
        width: 7px;
        height: 5px;
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
    /deep/ ::-webkit-scrollbar-track-piece {
        background-color: #ffff;
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
    /deep/ ::-webkit-scrollbar-thumb:vertical {
        height: 5px;
        background-color: rgba(144, 147, 153, 0.5);
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
    /deep/ ::-webkit-scrollbar-thumb:horizontal {
        width: 7px;
        background-color: rgba(144, 147, 153, 0.5);
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
}
</style>
